module.exports = __webpack_public_path__ + "static/media/8OLA12.757061e3.jpg";